import { IRelatedLink } from '@models/IRelatedLink';
import RelatedLinkCard from '@molecules/RelatedLinkCard/RelatedLinkCard';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';

interface Props {
  readonly title: string;
  readonly links: IRelatedLink[];
}

const RelatedLinks = ({ title, links }: Props) => (
  <div
    className="component-padding"
    data-testid="CT-38-Related-Links-Navigation"
  >
    <SoftLoadWrapper>
      {title && (
        <p className="h6" data-testid="CT-38-Related-Links-Navigation-Title">
          {title}
        </p>
      )}
      {links?.length > 0 && (
        <div className="mt-5 lg:mt-7.5">
          {links.map((link, index) => (
            <RelatedLinkCard
              key={`${link.url}-${link.name}`}
              dataTestId={`CT-38-Related-Links-Navigation-Card-${index}`}
              {...link}
            />
          ))}
        </div>
      )}
    </SoftLoadWrapper>
  </div>
);

export default RelatedLinks;
